import { useQuery } from "@tanstack/react-query";
import { useTranslations } from "use-intl";

import { Skeleton } from "@lawline/ui/components/skeleton";

import { useAuth } from "@platform/auth/context";
import { invitationsQueryOptions, membersQueryOptions } from "../tenant.queries";
import type { RosterRow } from "../tenant.types";
import { InviteMemberDialog } from "./invite-member";
import { MembersTable } from "./members-table";

export function MembersSection() {
	const t = useTranslations("tenant.members");
	const { can } = useAuth();
	const canManage = can({ invitation: ["create"] });
	const { data: members, isPending, error } = useQuery(membersQueryOptions);
	const { data: invitations } = useQuery({
		...invitationsQueryOptions,
		enabled: canManage,
	});

	const rows: RosterRow[] = [
		...(members ?? []).map((m) => ({
			id: m.id,
			kind: "member" as const,
			status: m.status,
			name: m.name,
			email: m.email,
			role: m.role,
			member: m,
		})),
		...(invitations ?? []).map((i) => ({
			id: i.id,
			kind: "invitation" as const,
			status: "pending" as const,
			name: "",
			email: i.email,
			role: i.role,
			invitation: i,
		})),
	];

	return (
		<section className="flex flex-col gap-6">
			{isPending ? (
				<Skeleton className="h-24 w-full" />
			) : error ? (
				<p className="text-destructive text-sm">{t("loadError")}</p>
			) : (
				<MembersTable rows={rows} action={canManage ? <InviteMemberDialog /> : null} />
			)}
		</section>
	);
}
